module.exports = __webpack_public_path__ + "img/Scan.fa2306cab.svg";